<div class="{{ className }}">
  <div class="{{ className }}__wrapper">
    <breadcrumbs></breadcrumbs>

    @if (isLoading || results === undefined) {
      <skeleton-cards-list
        [title1]="'Results'"
        [title2]="categorySuggested['applications'].length > 0 ? 'Suggested Apps' : ''"
        [context]="'/private/result'"></skeleton-cards-list>
    }
    @if (!isLoading && results !== undefined) {
      <div class="{{ className }}__results">
        @if (results.length > 0) {
          <h3 class="{{ className }}__title">
            {{ results.length }} {{ results.length == 1 ? 'Result' : 'Results' }}
          </h3>
          <cards-list
            (refreshDataEmitter)="refreshData()"
            [itemsList]="results"
            [theme]="theme"
            [isDesktop]="isDesktop"
            [width]="width"
            [categoryFeaturedId]="categoryFeaturedId"
            [categorySuggestedId]="categorySuggestedId"
            [categorySpecialId]="categorySpecialId"
            [categoryPurchasedId]="categoryPurchasedId"
            [categoryMostPurchasedId]="categoryMostPurchasedId"
            [categoryFeatured]="categoryFeatured"
            [categorySuggested]="categorySuggested"
            [categorySpecial]="categorySpecial"
            [categoryPurchased]="categoryPurchased"
            [categoryMostPurchased]="categoryMostPurchased"
            [context]="'/private/result'"
            [title2]="categorySuggested['applications'].length > 0 ? 'Suggested Apps' : ''"
            [showButtons]="true"
            [showTagsList]="true"
            [showText]="showText"></cards-list>
        } @else {
          <app-empty
            [img]="img"
            [title]="title"
            [itemsList]="[]"
            [description]="description"
            [buttonText]="buttonText"
            [buttonUrl]="buttonUrl"
            [theme]="theme"
            [isDesktop]="isDesktop"
            [width]="width"
            [categoryFeaturedId]="categoryFeaturedId"
            [categorySuggestedId]="categorySuggestedId"
            [categorySpecialId]="categorySpecialId"
            [categoryPurchasedId]="categoryPurchasedId"
            [categoryMostPurchasedId]="categoryMostPurchasedId"
            [categoryFeatured]="categoryFeatured"
            [categorySuggested]="categorySuggested"
            [categorySpecial]="categorySpecial"
            [categoryPurchased]="categoryPurchased"
            [categoryMostPurchased]="categoryMostPurchased"
            [context]="'/private/result'"
            [title2]="categorySuggested['applications'].length > 0 ? 'Suggested Apps' : ''"
            [showButtons]="true"
            [showTagsList]="true"
            [showText]="showText"></app-empty>
        }
      </div>
    }
  </div>
</div>